import { render, staticRenderFns } from "./referralPage.vue?vue&type=template&id=7d0dbdf0&scoped=true"
import script from "./referralPage.vue?vue&type=script&lang=js"
export * from "./referralPage.vue?vue&type=script&lang=js"
import style0 from "./referralPage.vue?vue&type=style&index=0&id=7d0dbdf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0dbdf0",
  null
  
)

export default component.exports